export default "__VITE_ASSET__4wFe4snx__"